import React, { Component, ReactNode, ReactElement } from 'react';
import type { UploadProps } from 'antd';
import { Button, Upload as AntdUpload } from 'antd';
// @ts-ignore
import SparkMD5 from 'spark-md5';
import { UploadFile } from 'antd';
import { ossSignUrl, getOSSUploadSignUrl, OSSHeaders, getFileMD5 } from '@/api/grt/upload';
export const obsSignUrl = ossSignUrl;
export enum UploadType {
    // eslint-disable-next-line no-unused-vars
    UNSET,
    // eslint-disable-next-line no-unused-vars
    IMAGE = 4,
    // eslint-disable-next-line no-unused-vars
    VIDEO = 2,
    // eslint-disable-next-line no-unused-vars
    AUDIO,
    // eslint-disable-next-line no-unused-vars
    DOCS = 5,
    // eslint-disable-next-line no-unused-vars
    USER_AVATAR,
    // eslint-disable-next-line no-unused-vars
    APP,
    // eslint-disable-next-line no-unused-vars
    AI = 21,
    AGENT
}

// eslint-disable-next-line no-unused-vars
export enum Accept {
    // eslint-disable-next-line no-unused-vars
    UNSET = '*',
    // eslint-disable-next-line no-unused-vars
    APP = '.ipa,.apk,.exe,.deb,.msi,.dmg,.app',
    // eslint-disable-next-line no-unused-vars
    IMAGE = 'image/png,image/jpeg,image/gif',
    // eslint-disable-next-line no-unused-vars
    VIDEO = 'video/mpeg,video/mp4,video/3gpp',
    // eslint-disable-next-line no-unused-vars
    DOCS = 'application/msword,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/json,application/vnd.ms-powerpoint,text/plain,application/vnd.ms-works,application/vnd.ms-excel,application/zip,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/xml,application/xml,.zip,.rar',
    // eslint-disable-next-line no-unused-vars
    AUDIO = 'audio/mpeg,audio/3gpp',
    // eslint-disable-next-line no-unused-vars
    USER_AVATAR = 'image/png,image/jpeg',
    AGENT = '.zip,.pdf,.doc,.docx'
}

interface genUrlResult {
    success: boolean;
    data: string | undefined | null;
}

export interface Props {
    sizeTip?: string;
    typeTip?: string;
    /** 自定义上传元素*/
    uploadItem?: ReactNode;
    customUploadType?: Array<string>;
    uploadType?: UploadType;

    /** 自定义class*/
    className?: string;
    // eslint-disable-next-line no-unused-vars
    onChange?: (file: UploadFile) => void;
    dirname?: string;
    /** 桶名*/
    bucketName: string;

    /** 上传前回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars
    beforeUpload?: (file: UploadFile, name: string, md5: string) => Promise<boolean | undefined | void>;
    /** 上传中回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars
    processFunc?: (processNumber: number, file: UploadFile, xhr: XMLHttpRequest, obsResult: any) => void;
    // eslint-disable-next-line no-unused-vars

    /** 上传完成回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars
    completeFunc?: (obsResult: any, file: UploadFile) => void;

    /** 上传失败回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars
    errorFunc?: (error: any, file: UploadFile, obsResult: any) => void;
    // eslint-disable-next-line no-unused-vars

    // eslint-disable-next-line no-unused-vars
    itemRender?: (originNode: ReactElement, file: UploadFile, fileList: object[], actions: any) => ReactNode;
    /** 文件大小限制*/
    maxSize?: number;
    /** 多个文件上传*/
    multiple?: boolean;
    disabled?: boolean;
}

type FileExtType = {
    [name: symbol]: string[];
};
type FileExtMap = {
    [name: number]: symbol;
};

interface State {}

const FILE_EXT_SYMBOL_IMAGE = Symbol('IMAGE'),
    FILE_EXT_SYMBOL_VIDEO = Symbol('VIDEO'),
    FILE_EXT_SYMBOL_DOCS = Symbol('DOCS'),
    FILE_EXT_SYMBOL_AUDIO = Symbol('AUDIO'),
    FILE_EXT_SYMBOL_APP = Symbol('APP'),
    FILE_EXT_SYMBOL_USER_AVATAR = Symbol('USER_AVATAR'),
    FILE_EXT_SYMBOL_AGENT = Symbol('AGENT');
const FILE_EXT_MAP: FileExtMap = {
    [UploadType.IMAGE]: FILE_EXT_SYMBOL_IMAGE,
    [UploadType.DOCS]: FILE_EXT_SYMBOL_DOCS,
    [UploadType.VIDEO]: FILE_EXT_SYMBOL_VIDEO,
    [UploadType.AUDIO]: FILE_EXT_SYMBOL_AUDIO,
    [UploadType.USER_AVATAR]: FILE_EXT_SYMBOL_USER_AVATAR,
    [UploadType.AI]: FILE_EXT_SYMBOL_VIDEO,
    [UploadType.APP]: FILE_EXT_SYMBOL_APP,
    [UploadType.AGENT]: FILE_EXT_SYMBOL_AGENT
};
const FILE_EXT: FileExtType = {
    [FILE_EXT_SYMBOL_IMAGE]: ['jpg', 'gif', 'png', 'jpeg'],
    [FILE_EXT_SYMBOL_VIDEO]: ['mp4', 'mov', 'm4v', 'flv', 'wmv', 'avi', 'rmvb', '3gp', 'mkv'],
    [FILE_EXT_SYMBOL_DOCS]: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'csv', 'txt', 'zip', 'rar'],
    [FILE_EXT_SYMBOL_AUDIO]: ['mp3', 'mpeg', 'wma'],
    [FILE_EXT_SYMBOL_USER_AVATAR]: ['jpg', 'png', 'jpeg'],
    [FILE_EXT_SYMBOL_APP]: ['ipa', 'apk', 'exe', 'deb', 'msi', 'dmg', 'app'],
    [FILE_EXT_SYMBOL_AGENT]: ['zip', 'pdf', 'doc', 'docx']
};

class Upload extends Component<Props, State> {
    state: State = {};

    xhrUploadFile(uploadUrl: string, file: any, headers: any, obsResult: any = {}) {
        const xhr = new XMLHttpRequest();
        xhr.open('put', uploadUrl);
        for (let key in headers) {
            const value = headers[key];
            if (key) {
                xhr.setRequestHeader(key, value);
            }
        }
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                if (this.props.processFunc) this.props.processFunc(event.loaded / event.total, file, xhr, obsResult);
            }
        };
        xhr.onerror = (err) => {
            if (this.props.errorFunc) {
                console.error(err);
                this.props.errorFunc(err, file, obsResult);
            }
        };
        xhr.onload = () => {
            if (xhr.status === 200) {
                if (this.props.completeFunc) {
                    console.log('complete:');
                    const url: string = xhr.responseURL;
                    obsResult.fileUrl = url.substring(0, url.indexOf('?'));
                    this.props.completeFunc(obsResult, file);
                }
            }
        };
        xhr.send(file);
        return xhr;
    }

    get uploadItem(): ReactNode {
        return this.props.uploadItem ? this.props.uploadItem : <Button>上传</Button>;
    }

    getAccept(type: UploadType): Accept {
        let accept: Accept = Accept.UNSET;
        switch (type) {
            case UploadType.AUDIO:
                accept = Accept.AUDIO;
                break;
            case UploadType.DOCS:
                accept = Accept.DOCS;
                break;
            case UploadType.IMAGE:
                accept = Accept.IMAGE;
                break;
            case UploadType.VIDEO:
                accept = Accept.VIDEO;
                break;
            case UploadType.UNSET:
                accept = Accept.UNSET;
                break;
            case UploadType.USER_AVATAR:
                accept = Accept.USER_AVATAR;
                break;
            case UploadType.AI:
                accept = Accept.VIDEO;
                break;
            case UploadType.APP:
                accept = Accept.APP;
                break;
            case UploadType.AGENT:
                accept = Accept.AGENT;
                break;
        }
        return accept;
    }

    uploadOption: UploadProps = {
        accept: this.getAccept(this.props.uploadType || UploadType.UNSET),
        itemRender: this.props.itemRender || (() => null),
        beforeUpload() {
            return false;
        },
        multiple: this.props.multiple || false,
        onChange: async ({ file }) => {
            if (file.status) return false;
            const { name } = file;
            let { fileExt } = this.getFileExtAndName(name);
            if (this.props.uploadType !== undefined && this.props.uploadType !== null) {
                if (UploadType.UNSET !== this.props.uploadType) {
                    const fileExtMap = FILE_EXT_MAP[this.props.uploadType];
                    if (!fileExtMap) {
                        if (this.props.errorFunc) {
                            this.props.errorFunc(
                                {
                                    message: this.props?.typeTip || '文件格式不支持',
                                    size: file.size,
                                    maxSize: this.props.maxSize
                                },
                                file,
                                {}
                            );
                        }
                        return false;
                    }
                    const extList = FILE_EXT[fileExtMap];
                    if (fileExt && !extList.includes(fileExt.toLowerCase())) {
                        if (this.props.errorFunc) {
                            this.props.errorFunc(
                                {
                                    message: this.props?.typeTip || '文件格式不支持',
                                    size: file.size,
                                    maxSize: this.props.maxSize
                                },
                                file,
                                {}
                            );
                        }
                        return false;
                    }
                }
            } else {
                const extList = Object.getOwnPropertySymbols(FILE_EXT);
                let isIn = false;
                for (let i = 0, len = extList.length; i < len; i++) {
                    const symbol = extList[i];
                    if (FILE_EXT[symbol] && FILE_EXT[symbol].includes(fileExt.toLowerCase())) {
                        isIn = true;
                        break;
                    }
                }
                if (!isIn) {
                    if (this.props.errorFunc)
                        this.props.errorFunc(
                            {
                                message: this.props?.typeTip || '文件格式不支持',
                                size: file.size,
                                maxSize: this.props.maxSize
                            },
                            file,
                            {}
                        );
                    return false;
                }
            }

            if (this.props.maxSize && file.size && file.size > this.props.maxSize) {
                if (this.props.errorFunc) {
                    this.props.errorFunc(
                        {
                            message: this.props?.sizeTip || '文件大小超出限制',
                            size: file.size,
                            maxSize: this.props.maxSize
                        },
                        file,
                        {}
                    );
                }
                return false;
            }
            if (this.props.onChange) {
                this.props.onChange(file);
            }
            await getFileMD5(file).then(async (md5) => {
                const rename = md5 + '.' + fileExt,
                    fileKey = this.props.dirname ? this.props.dirname + '/' + rename : rename,
                    { data, success } = await getOSSUploadSignUrl(obsSignUrl, this.props.bucketName, fileKey);
                if (!success) return false;

                if (this.props.beforeUpload) {
                    const beforeFlag = await this.props.beforeUpload(file, fileKey, md5 as string);
                    if (!beforeFlag && beforeFlag !== undefined) return false;
                }

                this.xhrUploadFile(data, file, OSSHeaders, {
                    bucketName: this.props.bucketName,
                    objectKey: fileKey,
                    md5,
                    ext: fileExt
                });
            });
        }
    };

    getFileExtAndName(fileName: string) {
        const index = fileName.lastIndexOf('.'),
            ext = fileName.substring(index + 1),
            name = fileName.substring(0, index);
        return { fileExt: ext, fileName: name };
    }

    render(): ReactNode {
        return (
            <AntdUpload {...this.uploadOption} disabled={this.props.disabled}>
                {this.uploadItem}
            </AntdUpload>
        );
    }
}

export default Upload;
